import { detectBrowserPlatform, type PlatformKind } from './platform';

export type ShortcutMode = 'auto' | 'raw';

function isMetaKey(key: string): boolean {
  return key === 'Meta' || key === 'MetaLeft' || key === 'MetaRight' || key === 'OS';
}

function isControlKey(key: string): boolean {
  return key === 'Control' || key === 'ControlLeft' || key === 'ControlRight' || key === 'Ctrl';
}

/**
 * 把本机主修饰键映射成远端系统常用的主修饰键。
 *
 * auto 模式只处理 Command/Ctrl 这一组，不改动 Alt、Shift 和普通字符。
 * raw 模式完整保留原始按键，便于发送 Windows/Meta 键做系统配置或调试。
 */
export function adaptShortcutKey(
  key: string,
  remotePlatform: PlatformKind,
  mode: ShortcutMode = 'auto',
  localPlatform: PlatformKind = detectBrowserPlatform(),
): string {
  if (mode === 'raw') return key;

  if (localPlatform === 'macos' && (remotePlatform === 'windows' || remotePlatform === 'linux') && isMetaKey(key)) {
    return key === 'MetaRight' ? 'ControlRight' : 'ControlLeft';
  }

  if ((localPlatform === 'windows' || localPlatform === 'linux') && remotePlatform === 'macos' && isControlKey(key)) {
    return key === 'ControlRight' ? 'MetaRight' : 'MetaLeft';
  }

  return key;
}
